// extracted by mini-css-extract-plugin
export default {"content":"layout-main-module--content--yEmA2","with-bottom-offset":"layout-main-module--with-bottom-offset--E1XGC","withBottomOffset":"layout-main-module--with-bottom-offset--E1XGC"};